<template>
  <div class="product ba" v-bind:class="{contrasted: isPageContrasted, fontBigger: isFontBigger}">
    <header class="page-header" data-aos="fade-up">
      <div class="container">
        <div class="heading-text" data-aos="fade-up">Bridge Alfa</div>
        <p data-aos="fade-up" data-aos-delay="100"></p>
        <span class="line" data-aos="zoom-in-left" data-aos-delay="150"></span>
        <p data-aos="fade-up" data-aos-delay="200"></p>
      </div>
    </header>

    <div id="top" class="why-us-solution">
      <div class="elements">
        <div class="element bps clearfix">
          <div class="text-box">
            <ul v-if="lang === 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
             W kwietniu 2016 LSI Fund stało się znaczącym udziałowcem Bioseco. Pieniądze, za które Fundusz objął udziały w 80% pochodziły ze wsparcia NCBIR. Te pieniądze pozwoliły Bioseco rozwinąć stereoskopową technologię wizyjną i zaprojektować pierwsze wersje prototypów urządzenia przeznaczonego dla operatorów farm wiatrowych oraz lotnisk. Urządzenia w wersji MVP zostały potem zaimplementowane u pierwszych branżowych klientów Bioseco. Niewątpliwym sukcesem tego etapu działalności Bioseco był fakt, że po zainstalowaniu urządzeń śmiertelność ptaków pod turbinami spadła do zera.
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
                W okresie 04.2016-05.2019 Bioseco S.A. realizowała projekt pod tytułem „Bioseco” w ramach Programu Operacyjnego Inteligentny Rozwój 2014-2020, Priorytet 1, Działanie 1.3,
Poddziałanie 1.3.1 – Wsparcie Projektów Badawczo-Rozwojowych w fazie preseed przez fundusze typu Proof of Concept – Bridge Alfa.
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
                  Cel projektu:<br/>
Celem Projektu było zaprojektowanie, wytworzenie oraz wdrożenie na rynek innowacyjnego urządzenia wspomagającego rozwój inwestycji energetycznych i lotniskowych oraz procesy prowadzenia badań środowiskowych.
 <br/><br/><br/>
                Wartosć projektu:<br/>
                3 000 000,00PLN
                  <br/><br/>
                  Dofinansowanie projektu z UE:<br/>
                2 400 000.00PLN
                </span>
              </li>
            </ul>
            <ul v-if="lang !== 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
               In April 2016, LSI Fund became a significant shareholder in Bioseco. 80% of the money for which the Fund acquired shares came from the NCBIR support. These funds have allowed Bioseco to develop stereoscopic vision technology and to design the first versions of device prototypes for wind farm and airports. The devices in the MVP version were later implemented at the first customers of Bioseco. The undoubted success of this stage of Bioseco's activity was the fact that after installing the devices, the mortality of birds where the system was operating dropped to zero.
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
                04.2016-05.2019 Bioseco SP. z o.o. realized project called “Bioseco” within the Operational Programme Smart Growth 2014-2020, Priority 1, Measure 1.3.,
Sub- measure 1.3.1 - Support for R&D projects at the ‘pre-seed’ stage by proof of concept funds – Bridge Alfa
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
               The aim of the Project was to design, manufacture and implement to the market an innovative tool supporting the development of energy and airport investments and the processes of conducting the environmental assessment.
                <br/><br/><br/>
                Project value:<br/>
                3 000 000,00PLN
                  <br/><br/>
                 Amount of founding from UE:<br/>
                2 400 000.00PLN
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../store/store';
  import FooterMain from '../components/FooterMain';
  import FooterMoreInformation from '../components/FooterMoreInformation';
  import VideoBox from '../components/VideoBox';
  import Counter from '../components/Counter';
  import smoothScroll from '../helpers/SmoothScroll';

  export default {
    name: 'farms-product',
    components: {
      FooterMain,
      FooterMoreInformation,
      VideoBox,
      Counter
    },
    data: function () {
      return {
        circleValues: [
          {
            before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter'),
          },
        ]

      }
    },
    computed: {
      lang: () => {
        return store.state.lang;
      },
      isPageContrasted(){
        return store.state.isPageContrasted
      },
      isFontBigger(){
        return store.state.isPageFontBigger
      },
      smoothScroll: () => smoothScroll
    },
    methods: {},
    mounted: function () {
      store.state.isAccessibilityVisible = true;
    },
    destroyed: function () {
      store.state.isAccessibilityVisible = false;
    },
  }
</script>

<style>
  .ba header.page-header .heading-text {
    max-width: 700px;
  }

  .product.ba .page-header {
    background: url(/static/img/product/header-area.jpg) no-repeat !important;
    background-position: center center !important;
    background-size: cover !important;
    min-height: 100px;
    padding-bottom: 60px;
  }

  .product .why-us-solution .elements .element.bps .text-box {
    float: left;
    max-width: initial;
    margin-top: 20px;
    margin-bottom: 100px;
  }

  .product .why-us-solution .elements .element.bps .text-box ul li .text {
    margin-top: -20px;
  }

  .ue{
    position: fixed;
    bottom: 0px;
    left: 0;
    right: 0;
    text-align: center;
  }

  .ue img{
    max-width: 940px;
    width: 35%;
  }

  .product.contrasted{
    background: #000;
    color: yellow;
  }

  .product.contrasted .heading-text{
    color: yellow;
  }
  .product.contrasted .ue{
    background: #000;
  }

  .product.contrasted header a{
    color: yellow;
    background: #000;
  }
  .product.contrasted .btn{
    color: yellow;
    background: #000;
  }
  .product.fontBigger .why-us-solution .elements .element .text-box ul li .text{
    font-size: 1.6em;
    line-height: 1.6em;
  }

</style>



// WEBPACK FOOTER //
// BridgeAlfa.vue?4a2ac616